import { selectAllStrings } from '../language/languageSlice';
import { useSelector, useDispatch } from 'react-redux';
import '../../stylesheets/IOSRegsitrationPage.css';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { createiOSUser, login, getiOSUserPassword } from '../user/userSlice';
import ErrorMessage from '../../app/ErrorMessage';
import { unwrapResult } from '@reduxjs/toolkit';
import { getUdid } from '../../api/mobile';
import constants from '../../constants';

const IOSRegsitrationPage = () => {
    const strings = useSelector(selectAllStrings);
    const [agree, setAgree] = useState(false);
    const onAgreeChanged = event => setAgree(event.target.checked);
    const history = useHistory();
    const [info, setInfo] = useState({
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        idCode: '',
        address: '',
        postalCode: '',
        city: '',
        province: '',
        country: ''
    });
    const [registerRequestStatus, setRegisterRequestStatus] = useState('idle');
    const [error, setError] = useState('');


    const dispatch = useDispatch();

    const canRegister = info.firstName != '' && info.lastName != '' &&
            info.email != '' && (agree || constants.environment == 'iOS');

    const updateInfo = (property, value) => {
        setInfo({...info, [property]: value});
    };

    const registerClicked = async event => {
        event.preventDefault();
        if (canRegister) {
            try {
                setRegisterRequestStatus('pending');

                let resultAction = await dispatch(createiOSUser({
                    nome: info.firstName,
                    cognome: info.lastName,
                    email: info.email
                }));
                unwrapResult(resultAction);

                let id = resultAction.payload.id;
                let userLogin = resultAction.payload.user_login;
                if (id > 0) {
                    resultAction = await dispatch(getiOSUserPassword({
                        user_id: id,
                        email: info.email
                    }));
                    unwrapResult(resultAction);
                    let password = resultAction.payload.trim();

                    const udid = await getUdid();
                    await dispatch(login({
                        udid,
                        cardNumber: userLogin,
                        password
                    }));
                    window.localStorage.setItem('username', userLogin);
                    window.localStorage.setItem('password', password);

                    window.location = '/#/thank-you';
                } else {
                    setError('something_went_wrong');
                }

            } catch (err) {
                setError(err.message);
                setRegisterRequestStatus('idle');
            }
        }

    };

    return <div className="buy-access-page page" onTouchStart={e => e.stopPropagation()} onTouchMove={e => e.stopPropagation()}>
        <a className="go-back" onClick={history.goBack}></a>
        <h1>{strings.your_information}</h1>
        <p>{strings.enter_info}</p>
        {window.location.port == 3000 ?
                    <p>port: 3000</p> :
                        null}
        <form>
            <label>
                {strings.insert_first_name}
            </label>
            <input type="text" placeholder={strings.first_name} onChange={event => updateInfo('firstName', event.target.value)}/>
    
            <label>
                {strings.insert_last_name}
            </label>
            <input type="text" placeholder={strings.last_name} onChange={event => updateInfo('lastName', event.target.value)}/>
    
            <label>
                {strings.insert_phone}
            </label>
            <input type="text" placeholder={strings.mobile_phone} onChange={event => updateInfo('phone', event.target.value)}/>
    
            <label>
                {strings.insert_email}
            </label>
            <input type="text" placeholder="E-mail" onChange={event => updateInfo('email', event.target.value)}/>
    
            <label>
                {strings.insert_code}
            </label>
            <input type="text" placeholder={strings.id_code} onChange={event => updateInfo('idCode', event.target.value)}/>
    
            <label>
                {strings.insert_address}
            </label>
            <input type="text" placeholder={strings.street_address} onChange={event => updateInfo('address', event.target.value)}/>
    
            <label>
                {strings.insert_postal_code}
            </label>
            <input type="text" placeholder={strings.postal_code} onChange={event => updateInfo('postalCode', event.target.value)}/>
    
            <label>
                {strings.insert_city}
            </label>
            <input type="text" placeholder={strings.city} onChange={event => updateInfo('city', event.target.value)}/>
    
            <label>
                {strings.insert_province}
            </label>
            <input type="text" placeholder={strings.province} onChange={event => updateInfo('province', event.target.value)}/>
    
            <label>
                {strings.insert_country}
            </label>
            <input type="text" placeholder={strings.country} onChange={event => updateInfo('country', event.target.value)}/>
            {constants.environment == 'iOS' ? null :
                    <React.Fragment>
                        <input type="checkbox" id="agree_checkbox" required className="custom-checkbox" checked={agree} onChange={onAgreeChanged}/> <label htmlFor="agree_checkbox" id="agree">
                            <span id="agree_label">{strings.you_agree_to}  <a href="https://www.pleinairclub.it/privacy-app" target="_blank">{strings.terms_and_conditions}</a> {strings.of_planairclub}</span>
                        </label>
                    </React.Fragment>}
            <a className="btn" id="buy_card"
               onClick={registerClicked}
               disabled={!canRegister}
               >{registerRequestStatus === 'pending' ? <div className="loader"></div> : strings.register_now}
            </a>
            <div className="support">{strings.for_any} <a href="tel:0685305377">0685305377</a> 
                {constants.environment == 'iOS' ? null :
                    <React.Fragment>
                        {strings.or_write} 
                        <a href="mailto:info@pleinairclub.it">info@pleinairclub.it</a>
                    </React.Fragment>}
            </div>
        </form>
        {error.length > 0 ? <ErrorMessage strings={strings} message={error} onGoBack={() => setError('')}/> : null}
    </div>;
};

export default IOSRegsitrationPage;